import { render, staticRenderFns } from "./ProcurationRefuseOrCancellation.vue?vue&type=template&id=5bd1c7f7&scoped=true&"
import script from "./ProcurationRefuseOrCancellation.vue?vue&type=script&lang=js&"
export * from "./ProcurationRefuseOrCancellation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd1c7f7",
  null
  
)

export default component.exports